import axios from 'axios'

import { env } from '@/utils/env'
import { buildQueryStr } from '@/utils/string'

import { HttpClient } from './HttpClient'

const apiAxios = axios.create({
  // 开发环境因为要使用vite.config.ts中的反向代理解决跨域问题
  baseURL: env.MODE === 'development' ? location.origin : env.PT_API_BASE_URL,
  timeout: env.PT_API_TIMEOUT,
  paramsSerializer: (params) => buildQueryStr(params)
})

// 不在这里直接注册拦截器，是因为ApiInterceptor中使用了apiAxios，在这里注册拦截器会形成循环依赖
export const apiClient = new HttpClient(apiAxios)

const instance = axios.create({
  timeout: env.PT_API_TIMEOUT,
  paramsSerializer: (params) => buildQueryStr(params)
})
// 普通HTTP客户端，没有API相关的拦截器
export const httpClient = new HttpClient(instance)
